(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = function (cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* Overlays: menu, search, cart, size guide */
  var lastFocus = null;
  function open(id) {
    var el = document.getElementById(id); if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('input[type=search], button, a'); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeAll() {
    document.querySelectorAll('.lx-menu.is-open, .lx-search.is-open, .lx-drawer.is-open').forEach(function (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lx-open]'); if (o) { e.preventDefault(); closeAll(); open(o.dataset.lxOpen); return; }
    if (e.target.closest('[data-lx-close]')) { e.preventDefault(); closeAll(); return; }
    var c = e.target.closest('[data-lx-cart-open]'); if (c) { e.preventDefault(); openCart(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeZoom(); } });

  /* Cart drawer */
  function renderCart(cart) {
    document.querySelectorAll('[data-lx-count]').forEach(function (el) { el.textContent = el.closest('.lx-ico') && !cart.item_count ? '' : cart.item_count; });
    var lines = document.querySelector('[data-lx-lines]'), foot = document.querySelector('[data-lx-foot]'); if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="lx-drawer__empty"><p>Tu bolsa está vacía</p><a class="lx-btn lx-btn--ghost" href="' + root + 'collections/novedades">Descubrir novedades</a></div>';
      foot.style.display = 'none'; return;
    }
    foot.style.display = '';
    lines.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
      var opts = (it.options_with_values || []).map(function (o) { return esc(o.value); }).join(' · ');
      return '<div class="lx-line" data-key="' + it.key + '"><a class="lx-line__img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a><div>' +
        '<div class="lx-line__t">' + esc(it.product_title) + '</div><div class="lx-line__v">' + opts + '</div>' +
        '<div class="lx-line__row"><div class="lx-qty"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Añadir uno">+</button></div><span>' + fmt(it.final_line_price) + '</span></div>' +
        '<button type="button" class="lx-line__rm" data-q="0">Eliminar</button></div></div>';
    }).join('');
    var t = document.querySelector('[data-lx-total]'); if (t) t.textContent = fmt(cart.total_price);
    renderShip(cart); renderUpsells(cart);
  }
  function renderShip(cart) {
    var d = document.getElementById('lx-cart'), box = document.querySelector('[data-lx-ship]'); if (!d || !box) return;
    var free = Number(d.dataset.free || 0); if (!free || !cart.items.length) { box.hidden = true; return; }
    var left = free - cart.total_price; box.hidden = false;
    box.querySelector('[data-lx-ship-txt]').innerHTML = left > 0 ? 'Te faltan <b>' + fmt(left) + '</b> para el <b>envío gratis</b>' : '¡Ya tienes <b>envío gratis</b>!';
    box.querySelector('[data-lx-ship-bar]').style.width = Math.min(100, cart.total_price / free * 100) + '%';
    box.classList.toggle('is-done', left <= 0);
  }
  var upsCache = {};
  function renderUpsells(cart) {
    var d = document.getElementById('lx-cart'), box = document.querySelector('[data-lx-ups]'); if (!d || !box) return;
    if (!cart.items.length) { box.hidden = true; return; }
    var inCart = cart.items.map(function (i) { return i.product_id; }), pid = cart.items[0].product_id;
    var sale = Number(d.dataset.sale || 0); var cents = function (v) { return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : Number(v); };
    var draw = function (list) {
      var seen = {}, picks = list.filter(function (p) { if (seen[p.id] || inCart.indexOf(p.id) > -1) return false; seen[p.id] = 1; return p.variants && p.variants.some(function (v) { return v.available; }); }).slice(0, 3);
      if (!picks.length) { box.hidden = true; return; }
      box.hidden = false;
      box.querySelector('[data-lx-ups-list]').innerHTML = picks.map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || ''; if (img && img.src) img = img.src;
        if (img) img = String(img).replace(/^\/\//, 'https://') + (String(img).indexOf('?') > -1 ? '&' : '?') + 'width=200';
        var url = root + 'products/' + p.handle;
        var opts = p.variants.filter(function (v) { return v.available; }).map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('');
        return '<div class="lx-up"><a href="' + url + '" class="lx-up__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a><div class="lx-up__info"><a class="lx-line__t" href="' + url + '">' + esc(p.title) + '</a><span class="lx-line__v">' + (cents(p.variants[0].compare_at_price || 0) > cents(p.variants[0].price) ? '<s>' + fmt(cents(p.variants[0].compare_at_price)) + '</s> <b class="lx-sale-price">' + fmt(cents(p.variants[0].price)) + '</b>' : fmt(cents(p.variants[0].price))) + '</span><div class="lx-up__row"><select aria-label="Elige color y talla">' + opts + '</select><button type="button" class="lx-up__add" data-lx-up-add>Añadir</button></div></div></div>';
      }).join('');
    };
    if (upsCache[pid]) return draw(upsCache[pid]);
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8').then(function (r) { return r.json(); }).then(function (j) {
      var list = (j && j.products) || [];
      if (list.length >= 3) { upsCache[pid] = list; return draw(list); }
      return fetch(root + 'collections/' + (d.dataset.upsell || 'novedades') + '/products.json?limit=12').then(function (r) { return r.json(); }).then(function (c) { upsCache[pid] = list.concat(c.products || []); draw(upsCache[pid]); });
    }).catch(function () { box.hidden = true; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-up-add]'); if (!b) return;
    var id = Number(b.parentNode.querySelector('select').value); b.textContent = '…'; b.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function () { return getCart(); }).then(renderCart).catch(function () { b.textContent = 'Añadir'; b.disabled = false; });
  });
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function openCart() { getCart().then(function (c) { renderCart(c); closeAll(); open('lx-cart'); }); }
  window.lxOpenCart = openCart;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.lx-line [data-q]'); if (!b) return;
    var key = b.closest('.lx-line').dataset.key;
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Number(b.dataset.q) }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  });

  /* Header */
  var header = document.querySelector('[data-lx-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    if (header.classList.contains('lx-header--over')) {
      header.addEventListener('mouseenter', function () { header.classList.add('is-hover'); });
      header.addEventListener('mouseleave', function () { header.classList.remove('is-hover'); });
    }
  }
  var rot = document.querySelector('[data-lx-rot]');
  if (rot && rot.children.length > 1) {
    var ri = 0; setInterval(function () { rot.children[ri].classList.remove('is-on'); ri = (ri + 1) % rot.children.length; rot.children[ri].classList.add('is-on'); }, 4000);
  }

  /* Sale countdown (real end date from the shop metafield) */
  var cds = document.querySelectorAll('[data-lx-cd]');
  if (cds.length) {
    var daily = cds[0].hasAttribute('data-lx-daily');
    var nextMidnight = function () { var mx = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Mexico_City' })); var m = new Date(mx); m.setHours(24, 0, 0, 0); return Date.now() + (m - mx); };
    var endAt = daily ? nextMidnight() : new Date((cds[0].dataset.lxCd || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2')).getTime();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var s = Math.max(0, Math.floor((endAt - Date.now()) / 1000));
      if (!s && daily) { endAt = nextMidnight(); s = Math.floor((endAt - Date.now()) / 1000); }
      if (!s) { document.querySelectorAll('[data-lx-sale]').forEach(function (el) { el.style.display = 'none'; }); return false; }
      var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      cds.forEach(function (el) { el.textContent = txt; }); return true;
    };
    if (tick()) var cdTimer = setInterval(function () { if (!tick()) clearInterval(cdTimer); }, 1000);
  }

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.lx-fade, [data-lx-hero]').forEach(function (el) { io.observe(el); });
  } else document.querySelectorAll('.lx-fade, [data-lx-hero]').forEach(function (el) { el.classList.add('is-in'); });

  /* Collection: grid density + sort */
  document.querySelectorAll('[data-lx-cols]').forEach(function (b) {
    b.addEventListener('click', function () {
      var g = document.querySelector('[data-lx-grid]'); if (!g) return;
      g.dataset.cols = b.dataset.lxCols;
      document.querySelectorAll('[data-lx-cols]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      try { localStorage.setItem('lx-cols', b.dataset.lxCols); } catch (e) {}
    });
  });
  try { var sc = localStorage.getItem('lx-cols'); if (sc) { var sb = document.querySelector('[data-lx-cols="' + sc + '"]'); if (sb && getComputedStyle(sb).display !== 'none') sb.click(); } } catch (e) {}
  var sort = document.querySelector('[data-lx-sort]');
  if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });

  /* Product page */
  var zoom = document.querySelector('[data-lx-zoom]');
  function closeZoom() { if (zoom && zoom.classList.contains('is-open')) { zoom.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
  document.querySelectorAll('[data-lx-product]').forEach(function (box) {
    var data = JSON.parse(box.querySelector('[data-lx-json]').textContent);
    var sel = data.options.map(function (_, i) { var o = box.querySelector('[data-lx-opt="' + i + '"]'); var a = o && o.querySelector('.is-active'); return a ? a.dataset.val : null; });
    var sizeIdx = data.options.indexOf('Talla');
    var media = box.querySelector('[data-lx-media]'), dots = box.querySelectorAll('[data-lx-dots] i'), msg = box.querySelector('[data-lx-msg]');
    var pieceIdx = data.options.indexOf('Pieza'), colorIdx = data.options.indexOf('Color'), set = null;
    if (pieceIdx > -1 && sizeIdx > -1) {
      var pieces = []; data.variants.forEach(function (v) { if (pieces.indexOf(v.o[pieceIdx]) === -1) pieces.push(v.o[pieceIdx]); });
      if (pieces.indexOf('Conjunto') > -1 && pieces.indexOf('Pantalón') > -1) {
        var top = pieces.filter(function (x) { return x !== 'Conjunto' && x !== 'Pantalón'; })[0];
        var sizeBox = box.querySelector('[data-lx-opt="' + sizeIdx + '"]'), box2 = sizeBox.cloneNode(true);
        box2.removeAttribute('data-lx-opt'); box2.setAttribute('data-lx-opt2', '');
        var g = box2.querySelector('.lx-guide-btn'); if (g) g.remove();
        box2.querySelectorAll('[data-val]').forEach(function (x) { x.classList.remove('is-active'); });
        sizeBox.parentNode.insertBefore(box2, sizeBox.nextSibling);
        set = { top: top, sizeBox: sizeBox, box2: box2, size2: null };
        box2.addEventListener('click', function (e) {
          var b = e.target.closest('[data-val]'); if (!b) return;
          set.size2 = b.dataset.val;
          box2.querySelectorAll('[data-val]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          box2.querySelector('[data-lx-optval]').textContent = b.dataset.val; if (msg) msg.textContent = ''; update(false);
        });
      }
    }
    var isSet = function () { return set && sel[pieceIdx] === 'Conjunto'; };
    function piece(name, size) { return data.variants.filter(function (v) { return v.o[pieceIdx] === name && (colorIdx < 0 || v.o[colorIdx] === sel[colorIdx]) && (!size || v.o[sizeIdx] === size); })[0]; }
    function setLabels() {
      if (!set) return;
      var on = isSet(), l1 = set.sizeBox.querySelector('.lx-opt__lbl'), l2 = set.box2.querySelector('.lx-opt__lbl');
      set.box2.style.display = on ? '' : 'none';
      l1.firstChild.nodeValue = on ? 'Talla ' + set.top.toLowerCase() + ' ' : 'Talla ';
      l2.firstChild.nodeValue = 'Talla pantalón ';
      if (!set.size2) l2.querySelector('[data-lx-optval]').textContent = 'Selecciona tu talla';
    }
    function current() { return data.variants.filter(function (v) { return v.o.every(function (x, i) { return sel[i] === null || sel[i] === x; }); }); }
    function exact() { return data.variants.filter(function (v) { return v.o.every(function (x, i) { return sel[i] === x; }); })[0]; }
    function update(colorChanged, init) {
      var c = current()[0] || data.variants[0], ex = exact();
      var price = (ex || c).price, wasTxt = (ex || c).was;
      if (isSet()) {
        var tv = piece(set.top, sel[sizeIdx]) || piece(set.top), bv = piece('Pantalón', set.size2) || piece('Pantalón');
        if (tv && bv) { price = fmt(tv.c + bv.c); wasTxt = tv.cc && bv.cc ? fmt(tv.cc + bv.cc) : null; }
      }
      setLabels();
      box.querySelectorAll('[data-lx-price]').forEach(function (el) { el.textContent = price; });
      var was = box.querySelector('[data-lx-price-was]'); if (was && wasTxt) was.textContent = wasTxt;
      var ci = data.options.indexOf('Color'), models = ci > -1 ? [].slice.call(media.querySelectorAll('figure.is-model')).filter(function (f) { return f.dataset.color === sel[ci]; }) : [];
      if (colorChanged && (models.length || c.media)) {
        var fig = models.length ? models[0] : media.querySelector('[data-media="' + c.media + '"]');
        var vfig = c.media ? media.querySelector('[data-media="' + c.media + '"]') : null;
        if (vfig) media.insertBefore(vfig, media.firstElementChild);
        models.slice().reverse().forEach(function (f) { media.insertBefore(f, media.firstElementChild); });
        if (fig) { media.scrollTo({ left: 0 }); if (!init && window.innerWidth > 989) window.scrollTo({ top: Math.min(window.scrollY, box.offsetTop), behavior: 'smooth' }); }
      }
      if (ex && !init) { var u = new URL(location.href); u.searchParams.set('variant', ex.id); history.replaceState(null, '', u.toString()); }
    }
    box.querySelectorAll('[data-lx-opt]').forEach(function (o) {
      var i = Number(o.dataset.lxOpt);
      o.addEventListener('click', function (e) {
        var b = e.target.closest('[data-val]'); if (!b) return;
        sel[i] = b.dataset.val;
        o.querySelectorAll('[data-val]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        var lbl = o.querySelector('[data-lx-optval]'); if (lbl) lbl.textContent = b.dataset.val;
        if (msg) msg.textContent = '';
        update(data.options[i] === 'Color');
      });
    });
    if (sizeIdx > -1) { sel[sizeIdx] = null; var sl = box.querySelector('[data-lx-opt="' + sizeIdx + '"] [data-lx-optval]'); if (sl) sl.textContent = 'Selecciona tu talla'; }
    var btn = box.querySelector('[data-lx-atc]');
    function add() {
      if (isSet()) {
        var tv = sel[sizeIdx] ? piece(set.top, sel[sizeIdx]) : null, bv = set.size2 ? piece('Pantalón', set.size2) : null;
        if (!tv || !bv) { if (msg) msg.textContent = !tv ? 'Selecciona la talla de la ' + set.top.toLowerCase() + '.' : 'Selecciona la talla del pantalón.'; (tv ? set.box2 : set.sizeBox).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var lb = btn.textContent; btn.textContent = 'Añadiendo…'; btn.disabled = true;
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: tv.id, quantity: 1 }, { id: bv.id, quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function () { openCart(); })
          .catch(function () { if (msg) msg.textContent = 'No se pudo añadir a la bolsa. Inténtalo de nuevo.'; })
          .finally(function () { btn.textContent = lb; btn.disabled = false; });
      }
      var v = exact();
      if (!v) { if (msg) msg.textContent = 'Selecciona una talla para continuar.'; var so = box.querySelector('[data-lx-opt="' + sizeIdx + '"]'); if (so) so.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      var label = btn.textContent; btn.textContent = 'Añadiendo…'; btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { openCart(); })
        .catch(function () { if (msg) msg.textContent = 'No se pudo añadir a la bolsa. Inténtalo de nuevo.'; })
        .finally(function () { btn.textContent = label; btn.disabled = false; });
    }
    btn.addEventListener('click', add);
    var sticky = box.querySelector('[data-lx-sticky]');
    if (sticky) {
      sticky.querySelector('[data-lx-sticky-btn]').addEventListener('click', function () { if (isSet() ? sel[sizeIdx] && set.size2 : exact()) add(); else { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); add(); } });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(btn);
    }
    if (media && dots.length) media.addEventListener('scroll', function () { var k = Math.round(media.scrollLeft / media.clientWidth); dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); }); }, { passive: true });
    if (zoom && media) media.addEventListener('click', function (e) {
      var f = e.target.closest('figure'); if (!f || window.innerWidth < 990) return;
      var imgs = [].slice.call(media.querySelectorAll('img'));
      zoom.querySelector('[data-lx-zoom-imgs]').innerHTML = imgs.map(function (im) { return '<img src="' + im.currentSrc.replace(/width=\d+/, 'width=2000') + '" alt="">'; }).join('');
      zoom.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
      var idx = imgs.indexOf(f.querySelector('img')); var t = zoom.querySelectorAll('img')[idx]; if (t) t.onload = function () { t.scrollIntoView(); };
    });
    if (zoom) zoom.querySelector('[data-lx-zoom-close]').addEventListener('click', closeZoom);
    update(true, true);
  });
})();
